import { PuzzleSettings } from 'client/types/PuzzleSettings'
import { klubbleAPI } from './common'

export const saveSettings = async (settings: PuzzleSettings) => {
  const res = await klubbleAPI.post('/Puzzle/savesettings', settings)
  if (!res.data.success) {
    throw new Error('Error saving puzzle settings')
  }
}

export const saveSettingsBatch = async (settings: PuzzleSettings[]) => {
  const res = await klubbleAPI.post('/Puzzle/savesettings/batch', settings)
  if (!res.data.success) {
    throw new Error('Error saving puzzle settings')
  }
}
